import { Trial, IndicationInfo } from './types';

/** Indication name (or start of name) -> extra chart/table endpoints for SOC reports */
export const EXTRA_ENDPOINTS_MAPPING: Record<string, Array<{ id: string; label: string; expKey: keyof Trial; ctrlKey: keyof Trial }>> = {
  'Chronic Lymphocytic Leukemia': [
    { id: 'CRi', label: 'CRi', expKey: 'criExp', ctrlKey: 'criCtrl' },
  ],
  'Chronic Myeloid Leukemia': [
    { id: 'Hematological CR', label: 'Hematological CR', expKey: 'hematologicalCrExp', ctrlKey: 'hematologicalCrCtrl' },
    { id: 'Cytogenetic CR', label: 'Cytogenetic CR', expKey: 'cytogeneticCrExp', ctrlKey: 'cytogeneticCrCtrl' },
    { id: 'Cytogenetic Major Response', label: 'Cytogenetic Major Response', expKey: 'cytogeneticMajorResponseExp', ctrlKey: 'cytogeneticMajorResponseCtrl' },
    { id: 'Molecular Major Response', label: 'Molecular Major Response', expKey: 'molecularMajorResponseExp', ctrlKey: 'molecularMajorResponseCtrl' },
  ],
  'Multiple Myeloma': [
    { id: 'SCR', label: 'SCR', expKey: 'scrExp', ctrlKey: 'scrCtrl' },
    { id: 'VGPR', label: 'VGPR', expKey: 'vgprExp', ctrlKey: 'vgprCtrl' },
  ],
  'Acute Myeloid Leukemia': [
    { id: 'CRi', label: 'CRi', expKey: 'criExp', ctrlKey: 'criCtrl' },
  ],
  'Prostate Cancer': [
    { id: 'PSA50', label: 'PSA50', expKey: 'psa50Exp', ctrlKey: 'psa50Ctrl' },
  ],
};

export function getExtraEndpointsForIndication(indicationName: string | undefined): Array<{ id: string; label: string; expKey: keyof Trial; ctrlKey: keyof Trial }> {
  if (!indicationName?.trim()) return [];
  const name = indicationName.trim();
  for (const key of Object.keys(EXTRA_ENDPOINTS_MAPPING)) {
    if (name === key || name.startsWith(key + ' ') || name.startsWith(key + '-') || name.startsWith(key + '–')) {
      return EXTRA_ENDPOINTS_MAPPING[key];
    }
  }
  return [];
}

// This will be replaced with API calls
export const MOCK_TRIALS: Trial[] = [
  {
    id: "36041086",
    trialName: "EV-302",
    nccnNotes: "Cisplatin ineligible",
    preferredStatus: "Preferred",
    expDrug: "Enfortumab Vedotin + Pembrolizumab",
    ctrlDrug: "Chemotherapy",
    expN: 442,
    ctrlN: 444,
    orrExp: 67.7,
    orrCtrl: 44.4,
    crExp: 29.1,
    crCtrl: 12.5,
    mPFSExp: 12.5,
    mPFSCtrl: 6.3,
    pfsHR: 0.45,
    pfsHRCI: "0.38-0.54",
    mOSExp: 31.5,
    mOSCtrl: 16.1,
    osHR: 0.47,
    osHRCI: "0.38-0.58",
    g35AEExp: 55.9,
    g35AECtrl: 69.5,
    g5DeathExp: 4.3,
    g5DeathCtrl: 3.2,
    publicationDate: "2024-03-01"
  },
];

export const INDICATION_INFO: IndicationInfo = {
  name: "Bladder Cancer - 1L Systemic Therapy",
  nccnVersion: "2.2025"
};
